jQuery(document).ready(function() {
	
	var controller = new ScrollMagic.Controller();

	// build scene

	var scene = new ScrollMagic.Scene({
		triggerElement: "#bit-block_6013c2e1052b8",
		offset: 150
	})
	.setClassToggle("#bit-block_6013c2e1052b8.o-bit", "is-visible")
	// .addIndicators()
	.triggerHook("onEnter")
	.reverse(false)
	.addTo(controller);

	var scene = new ScrollMagic.Scene({
		triggerElement: "#bit-block_60179ffc6ce05",
		offset: 150
	})
	.setClassToggle("#bit-block_60179ffc6ce05", "is-visible")
	// .addIndicators()
	.triggerHook("onEnter")
	.reverse(false)
	.addTo(controller);

	var scene = new ScrollMagic.Scene({
		triggerElement: "#cta-block_6017a0406ce06",
		offset: 150
	})
	.setClassToggle("#cta-block_6017a0406ce06", "is-visible")
	// .addIndicators()
	.triggerHook("onEnter")
	.reverse(false)
	.addTo(controller);

	var scene = new ScrollMagic.Scene({
		triggerElement: "#bit-block_6017a0696ce07",
		offset: 150
	})
	.setClassToggle("#bit-block_6017a0696ce07", "is-visible")
	// .addIndicators()
	.triggerHook("onEnter")
	.reverse(false)
	.addTo(controller);

	var scene = new ScrollMagic.Scene({
		triggerElement: "#bit-block_6017a0bd6ce09",
		offset: 150
	})
	.setClassToggle("#bit-block_6017a0bd6ce09", "is-visible")
	// .addIndicators()
	.triggerHook("onEnter")
	.reverse(false)
	.addTo(controller);

	var scene = new ScrollMagic.Scene({
		triggerElement: "#bquote-block_602a5eac95578",
		offset: 150
	})
	.setClassToggle("#bquote-block_602a5eac95578", "is-visible")
	// .addIndicators()
	.triggerHook("onEnter")
	.reverse(false)
	.addTo(controller);

});